<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Settings">
    <mat-icon>settings</mat-icon>
</button>
<mat-menu #menu="matMenu">
    <button mat-menu-item aria-label="Log ud" matTooltip="Log ud" (click)="handleLogoutClick()">
        <mat-icon>logout</mat-icon>
        <span>Log out</span>
    </button>
</mat-menu>